<script>
import {get} from "lodash";
import StarRating from 'vue-star-rating'

export default {
  name: "ContactCompanyRating",
  props: {
    column: {
      type: Object,
      default: () => ({})
    },
    row: {
      type: Object,
      default: () => ({})
    },
    editableRow: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    StarRating
  },
  computed: {
    rating() {
      return get(
        this.isEditRow ? this.editableRow : this.row,
        this.column.prop,
        0
      );
    },
    isEditRow () {
      return this.row.id === this.editableRow.id
    },
  },
  methods: {
    setRating(rating) {
      this.$emit('setRating', rating, this.column.prop);
    },
  }
}
</script>

<template>
  <div :class="['rating', {'is-editable': isEditRow}]">
    <StarRating
      :rating="rating"
      :border-width="0"
      :round-start-rating="false"
      :show-rating="false"
      :star-size="16"
      :read-only="!isEditRow"
      :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]"
      @rating-selected="setRating"
    />
  </div>
</template>

<style scoped lang="scss">

.rating {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  &.is-editable {
    margin-left: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCompany/ContactCompanyVisas/ContactCompanyRating.vue